<template>
  <v-container fluid fill-height class="primary">
    <LoginForm 
      @login="sendLogin" 
      :loading="userLoading"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import LoginForm from '@/components/auth/LoginForm';
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'Login',
  components: {
    LoginForm
  },

  methods: {
    ...mapMutations(["showNotification", "closeNotification", "setToken", "setUser"]),
    ...mapActions(['login', "setUsuario", "fetchColaboradores"]),
    async sendLogin(payload) {
      try {
        await this.login({ nome: payload.usuario, senha: payload.senha });
        this.$router.push('/');
      } catch (error) {
        this.showNotification({ text: error.message, status: 'error' });
      }
    }
  },

  computed: {
    ...mapGetters(['userLoading'])
  },

  created() {
    changePageTitle('Login');

    if (localStorage.getItem("token") && localStorage.getItem('user')) {
      this.setToken(localStorage.getItem("token"));
      this.setUser(JSON.parse(localStorage.getItem("user")));
      this.$router.push('/');
      this.showNotification({
        text: `${JSON.parse(localStorage.getItem("user")).Descricao}, Bem-vindo.`, status: 'success'
      });
    }
  },
};
</script>

<style>
</style>
